export const trimIframeSource = (reportUrl) => {
    const regex = /"(.*?)"/g;
    let result = reportUrl.match(regex);
    let tempSource = result[0];
    tempSource = tempSource.substr(1)
    tempSource = tempSource.substr(0, tempSource.length - 1)
    return tempSource
}